const mobileFormFieldsTypes = {
  text: { id: 1, value: 'text' },
  checkbox: { id: 2, value: 'checkbox' },
  textArea: { id: 3, value: 'textArea' },
  list: { id: 4, value: 'list' },
  listMultiple: { id: 4, value: 'listMultiple' },
  header: { id: 5, value: 'header' },
  radio: { id: 6, value: 'radio' }, // can be empty
  whitespace: { id: 7, value: 'whitespace' },
  signature: { id: 8, value: 'signature' },
  imgList: { id: 9, value: 'imgList' },
  locationDate: { id: 10, value: 'locationDate', typeAction: 0 },
  action: { id: 10, value: 'action', typeAction: 1 },
  emails: { id: 10, value: 'emails', typeAction: 2 },
  audio: { id: 11, value: 'audio' },
  checkboxGroup: { id: 12, value: 'checkboxGroup' },
  radios: { id: 13, value: 'radios' },
  loop: { id: 14, value: 'loop' },
  barcodeScan: { id: 15, value: 'barcodeScan' },
  asset: { id: 16, value: 'asset' },
  finalCustomer: { id: 17, value: 'finalCustomer' },
  attachments: { id: 18, value: 'attachments' },
};

const actionTypes = {
  [mobileFormFieldsTypes.locationDate.typeAction]: mobileFormFieldsTypes.locationDate,
  [mobileFormFieldsTypes.action.typeAction]: mobileFormFieldsTypes.action,
  [mobileFormFieldsTypes.emails.typeAction]: mobileFormFieldsTypes.emails,
};

const textfieldTypes = {
  DATE: { id: 0, name: 'date' },
  TEXT: { id: 1, name: 'text' },
  NUMBER: { id: 2, name: 'number' },
  CURRENCY: { id: 3, name: 'currency' },
  DATETIME: { id: 4, name: 'dateTime' },
  GEOLOCATION: { id: 5, name: 'geolocation' },
  TIME: { id: 6, name: 'time' },
};

export { mobileFormFieldsTypes, actionTypes, textfieldTypes };
